<template>
  <v-card>
    <v-system-bar dark window color="info">
      <v-icon center>mdi-information</v-icon>
      <v-toolbar-title class="ml-1">Информация о статистике</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small icon @click.native="$emit('close-dialog')">
        <v-icon class="mx-0">clear</v-icon>
      </v-btn>
    </v-system-bar>
    
    <v-card-text class="pt-1">
      <div class="mb-3">
        <h3 class="headline mb-0">{{data.name}}</h3>
        <div v-html="data.description"></div>
      </div>
      
      <v-expansion-panel expand>
        <v-expansion-panel-content>
          <div slot="header">Владелец</div>
          <v-card>
            <v-card-text class="grey lighten-3">
              <span v-if="this.owner">{{this.owner.name}}</span>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">Администраторы</div>
          <v-card>
            <v-card-text class="grey lighten-3">
              <ul v-if="admins_data.length>0">
                <li v-for="item in admins_data" :key="item.id">{{ item.name }}</li>
              </ul>
              <span v-else>Не назначены</span>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">Заполнящие</div>
          <v-card>
            <v-card-text class="grey lighten-3">
              <ul v-if="fillings_data.length>0">
                <li v-for="item in fillings_data" :key="item.id">{{ item.name }}</li>
              </ul>
              <span v-else>Не назначены</span>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        <v-expansion-panel-content>
          <div slot="header">Наблюдатели</div>
          <v-card>
            <v-card-text class="grey lighten-3">
              <ul v-if="watchers_data.length>0">
                <li v-for="item in watchers_data" :key="item.id">{{ item.name }}</li>
              </ul>
              <span v-else>Не назначены</span>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'
  
  export default {
    name : "StatisticsInfo",
    
    created(){
      this.getStatisticsParticipants()
    },
    
    props: {
      data: {
        type: Object,
        required: true,
      }
    },
    
    computed:{
      ...mapGetters('app/org', ['getPostById','getContainerById']),
    },
    
    data(){
      return {
        admins_data: [],
        watchers_data: [],
        fillings_data: [],
        owner: null,
      }
    },
    
    methods:{
      getStatisticsParticipants(){
        this.$store.dispatch('analytics_old/indicators/getParticipants', {id: this.data.id, type: 'all'}).then( response => {
          if(response.admins_data) this.admins_data = response.admins_data
          if(response.watchers_data) this.watchers_data = response.watchers_data
          if(response.fillings_data) this.fillings_data = response.fillings_data
          if(response.owner) this.owner = response.owner
    
          this.convertStatisticObjects()
        })
      },
  
      convertStatisticObjects(){
        let posts = []
        let containers = []
        this.admins_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name+' ('+post.fullname+')'
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
    
        this.fillings_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name+' ('+post.fullname+')'
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
    
        this.watchers_data.map( item => {
          if(item.element_type==='post'){
            let post = this.getPostById(item.element_id)
            if(post.loaded){
              item.name = post.name+' ('+post.fullname+')'
            } else if(!posts.includes(item.element_id)){
              posts.push(item.element_id)
            }
          } else if(item.element_type==='container'){
            let container = this.getContainerById(item.element_id)
            if(container.loaded){
              item.name = container.name
            } else if(!containers.includes(item.element_id)){
              containers.push(item.element_id)
            }
          }
        })
        
        if(this.owner){
          let post = this.getPostById(this.owner.id)
          if(post.loaded){
            this.owner.name = post.name+' ('+post.fullname+')'
          } else if(!posts.includes(this.owner.id)){
            posts.push(this.owner.id)
          }
        }
    
        //Запрос к оргструктуре на получение имен постов и вставка их в соответствующие места в заголовках таблицы
        if(posts.length>0){
          this.$store.dispatch('app/org/entitiesInfo', { posts, containers}).then( response => {
            //Запись постов в хранилище, чтобы не запрашивать при возможной отрисовке следующей таблицы
            this.$store.commit('app/org/addPosts', response.posts_data)
            this.$store.commit('app/org/addContainers', response.containers_data)
            //Парсинг имен объектов и замена uuid на соответствующее название поста
            this.admins_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name+' ('+post.fullname+')'
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
        
            this.fillings_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name+' ('+post.fullname+')'
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
        
            this.watchers_data.map( item => {
              if(item.element_type==='post'){
                let post = this.getPostById(item.element_id)
                if(post.loaded){
                  item.name = post.name+' ('+post.fullname+')'
                } else {
                  item.name = 'Неизвестный объект'
                }
              } else if(item.element_type==='container'){
                let container = this.getContainerById(item.element_id)
                if(container.loaded){
                  item.name = container.name
                } else {
                  item.name = 'Неизвестный объект'
                }
              }
            })
  
            if(this.owner){
              let post = this.getPostById(this.owner.id)
              if(post.loaded){
                this.owner.name = post.name+' ('+post.fullname+')'
              } else {
                this.owner.name = 'Неизвестный объект'
              }
            }
            
          })
        }
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/StatisticsInfo.vue